import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=540b189e&scoped=true&"
import script from "./Page1.vue?vue&type=script&lang=js&"
export * from "./Page1.vue?vue&type=script&lang=js&"
import style0 from "./Page1.vue?vue&type=style&index=0&id=540b189e&prod&lang=scss&"
import style1 from "./Page1.vue?vue&type=style&index=1&id=540b189e&prod&lang=scss&scoped=true&"
import style2 from "./Page1.vue?vue&type=style&index=2&id=540b189e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b189e",
  null
  
)

export default component.exports